import React from 'react';
import { motion } from 'framer-motion';
import CompanyProfile from '../../team/CompanyProfile';

const OverviewTab = ({ displayUser, isReadOnly, onUploadMedia }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <CompanyProfile organizationData={{ organization: displayUser?.uid || displayUser?.id }} />
    </motion.div>
  );
};

export default OverviewTab;
